module.exports = __webpack_public_path__ + "illus.88b4459dc59997222a9d9588c8076c0c.png";